import React from "react";
import tokenImage from "../../../assets/icons/tokenImage.png";
const Tokenomics = () => {
  const data = [
    {
      icon: tokenImage,
      text: "Invest and Earn easily.",
      desc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Dui semper quam faucibus volutpat vehicula ut at odio tincidunt.",
    },
    {
      icon: tokenImage,
      text: "Invest and Earn easily.",
      desc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Dui semper quam faucibus volutpat vehicula ut at odio tincidunt.",
    },
    {
      icon: tokenImage,
      text: "Invest and Earn easily.",
      desc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Dui semper quam faucibus volutpat vehicula ut at odio tincidunt.",
    },
  ];
  return (
    <section className="py-20 md:py-40">
      <div className="container">
        <h2 className="text-center text-[30px] md:text-[44px] font-semibold">
          Best <span className="text-primary "> Tokenomics</span>
        </h2>
        <p className="text-gray mx-auto max-w-md text-base md:text-lg mt-3 text-center ">
          Learn about how DEFI tokens
        </p>
        <div className=" grid md:grid-cols-3 gap-10 mt-20">
          {data.map((val, i) => (
            <div key={i} className=" bg-dark-500 rounded-xl p-4">
              <div className="grid grid-cols-2 justify-between items-center  border-b border-gray pb-6">
                <p className="text-[#C2C2C2] text-2xl flex-1 ">{val.text}</p>
                <img src={val.icon} alt="" className="ml-auto" />
              </div>
              <p className=" text-gray py-4">{val.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Tokenomics;
